// /src/pdf/builders/top40/buildDoc.js
export function buildTop40Doc({
  t, shortcode, stationName,
  year, month, monthLabel,
  rows, info, missingDates,
  fmtNumber, locale,
  logoDataUrl,
  serviceName
}) {
  const content = [];
  const stationTitle = stationName || shortcode || '';
  const serviceTitle = serviceName || (t && t('top40.title')) || '';

  // Логотип (если есть)
  if (logoDataUrl) {
    content.push({ image: logoDataUrl, width: 140, margin: [0, 0, 0, 10] });
  }

  // Заголовок и период
  content.push(
    ...(serviceTitle ? [{ text: serviceTitle, style: 'h1', margin: [0, 0, 0, 2] }] : []),
    ...(stationTitle ? [{ text: stationTitle, style: 'h1', margin: [0, 0, 0, 2] }] : []),
    {
      margin: [0, 0, 0, 6],
      fontSize: 10,
      color: '#666',
      stack: [
        `${t('top40.pick_month')}: ${monthLabel || `${year}-${String(month).padStart(2, '0')}`}`
      ],
    },
    {
      text: (t && t('pdf.made_on')) || 'Report made on Radiomonitor.net',
      fontSize: 10,
      color: '#666',
      margin: [0, 0, 0, 10],
    }
  );

  // Таблица TOP-40
  const header = [
    { text: t('top40.table.rank'), style: 'th', alignment: 'left' },
    { text: t('top40.table.artist'), style: 'th', alignment: 'left' },
    { text: t('top40.table.track'), style: 'th', alignment: 'left' },
    { text: t('top40.table.count'), style: 'th', alignment: 'right' },
  ];
  const body = [
    header,
    ...((rows || []).map((r, i) => ([
      { text: String(i + 1), alignment: 'left' },
      { text: r.artist || '', alignment: 'left' },
      { text: r.track || '', alignment: 'left' },
      { text: fmtNumber(r.count ?? 0, locale), alignment: 'right' },
    ])))
  ];

  content.push({
    table: {
      headerRows: 1,
      widths: ['auto', '*', '*', 'auto'],
      body
    },
    layout: {
      fillColor: (rowIndex) => (rowIndex === 0 ? '#f0f0f0' : null),
      hLineColor: '#e0e0e0',
      vLineColor: '#e0e0e0',
    },
    margin: [0, 0, 0, 8],
  });

  // Информационные строки (если есть)
  if (info) {
    content.push({ text: info, fontSize: 10, color: '#666', margin: [0, 0, 0, 4] });
  }
  if (Array.isArray(missingDates) && missingDates.length) {
    content.push({
      text: `${t('top40.missing_dates')}: ${missingDates.join(', ')}`,
      fontSize: 10,
      color: '#c00'
    });
  }

  return {
    pageSize: 'A4',
    pageMargins: [24, 28, 24, 36],
    footer: (current, totalPages) => ({
      margin: [24, 0, 24, 12],
      fontSize: 9,
      columns: [
        { text: `${(t && t('pdf.made_on')) || 'Report made on Radiomonitor.net'}`, alignment: 'left' },
        { text: `${current} / ${totalPages}`, alignment: 'right' },
      ],
    }),
    content,
    styles: {
      h1: { fontSize: 18, bold: true },
      th: { bold: true }
    },
  };
}

export { buildTop40Doc as default };
